import { render } from "./FulfillGoodsOrderDialog.vue?vue&type=template&id=747381f1"
import script from "./FulfillGoodsOrderDialog.vue?vue&type=script&lang=js"
export * from "./FulfillGoodsOrderDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__